import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/topics', schema => {
        const { models } = schema.topics.all();

        return models.map(({ id, name }) => ({ id, name }));
    });

    server.post('/v1/topics', (schema, { requestBody }) => {
        const { name, keywords, entity_type, entity_ids, type } = JSON.parse(requestBody);

        const { attrs } = schema.topics.create({
            name,
            keywords,
            entity_type,
            entity_ids,
            type
        });

        return attrs;
    });

    server.get('/v1/topics/:id', (schema, { params: { id } }) => {
        const topic = schema.topics.find(id);

        if (!topic) {
            return new Response(HTTP.NOT_FOUND);
        }

        return topic.attrs;
    });

    server.put('/v1/topics/:id', (schema, { params: { id }, requestBody }) => {
        const topic = schema.topics.find(id);

        if (!topic) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { name, keywords, entity_type, entity_ids, type } = JSON.parse(requestBody);

        topic.update({ name, keywords, entity_type, entity_ids, type });

        return topic.attrs;
    });

    server.delete('/v1/topics/:id', (schema, { params: { id } }) => {
        const topic = schema.topics.find(id);

        if (topic) {
            topic.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
